import { Container } from 'react-bootstrap';
import "../style/navs.css";
import "../style/footer.css"
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { db } from '../database/firebase';
import { collection,addDoc } from 'firebase/firestore';
import { useState } from 'react';
export default function Footer() {
  const[message,setmessage]=useState({
    name:"unknown",
    email:"",
    message:"No message"
  });
  const[loding,setloding]=useState(false);
  /*add */
  const addmessage = async () => {
    setloding(true);
    try {
      const docRef = await addDoc(collection(db, "message"), {
      name:"unknown",
      email:message.email,
      message:"No message",
      });
      console.log("Document ID:", docRef.id);
      setloding(false);
      setmessage({name:"",email:"",message:""})
     
    } catch (error) {
      console.error("Error adding document:", error);
    }
  };
  /*add*/
  const openWhatsApp = () => {
    const phone = ""+4917645345111; // ضع رقم الهاتف بصيغة دولية بدون +
    const url = `https://wa.me/${phone}`;
    window.open(url, "_blank");
  };
  const openFacebook = () => {
    const url = "https://www.facebook.com/people/Lamar-Reinigung-Gartenarbeit/pfbid0KQJVbE379CwfG2XzDsxebeV6Xi9StwAp5AxExpNKd9QuGnKEueXhTDa2imySHy9Wl/"; // استبدل بالرابط المطلوب
    window.open(url, "_blank");
  };
  const openYouTube = () => {
    const url = "https://www.youtube.com/@lamarreinigung"; // استبدل برابط القناة أو الفيديو
    window.open(url, "_blank");
  };
  return (
    <div className='Footer'>
      <Container>
        <div className='inside-footer'>
          <div className='frist'>
            <div className='logo'>
              <div className='logo-icon'>
                <i class='fa-solid fa-broom'></i>
              </div>
              <div className='logo-content'>
                <h5>
                  <span>lamar</span> reinigung
                </h5>
                <h6>Reinigungsunternehmen</h6>
              </div>
            </div>
            <p>Bleiben Sie auf dem Laufenden mit unseren neuesten Reinigungstipps, Service-Updates und hilfreichen Artikeln zur Pflege eines makellosen Zuhauses.</p>
            <div className='icons'>
            <i onClick={()=>openFacebook()} class="fa-brands fa-facebook"></i>
            <i onClick={()=>openWhatsApp()}  class="fa-brands fa-whatsapp"></i>
            <i onClick={()=>openYouTube()} class="fa-brands fa-youtube"></i>
            </div>
          </div>
          <div className='second'>
            <h3>Newsletter</h3>
            <Form>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email" placeholder="Enter email"  value={message.email} onChange={(e)=>setmessage({...message,email:e.target.value})}/>
      </Form.Group>
      </Form>
      <Button variant="success" onClick={()=>message.email!=="" ?addmessage():""}>{loding ? "Senden...":"schicken"}</Button>
          </div>
        </div>
        
        <div className='end-footer'>
        <hr/>
            <h6>2025 lamar-reinigung Alle Rechte vorbehalten</h6>
        </div>
      </Container>
    </div>
  );
}
